export const UPSCALE_IMAGINATION_STRENGTH_PRESETS = [
  "LOW",
  "MEDIUM",
  "HIGH",
  "CUSTOM",
] as const;
